import {
  AvailablePitchTypesAndGroupsDto,
  PracticePitcherSessionReportChartConfigDto,
  PracticePitcherSessionReportChartDataDto,
  DateRangeDto,
  PlayerReportContentConfigDto,
  SelectedItemDto,
} from 'types/CodegenReportTypes';
import { configurablePitchTypeGroups, configurablePitchTypes } from 'utilities/constants';

import { generateStore } from 'utilities/reportStoreFactory';

type ReportSpecificTypes = {
  // search criteria come from select fields and their type must match selected entries from ...FilterDto type
  searchCriteria: {
    sessionType: SelectedItemDto | undefined;
    dateRanges: DateRangeDto[] | undefined;
    seasonNames: string[] | undefined;
    players: SelectedItemDto[] | undefined;
  };
  // search chips type must match selected entries from ...ResultDto type
  searchChips: {
    seasonNames: string[] | undefined;
    dateRanges: DateRangeDto[] | undefined;
    playerNames: string[] | undefined;
  };

  // filters / config area
  specialConfigOptions: { pitchTypeInfo: AvailablePitchTypesAndGroupsDto } | undefined;
  selectedConfgValues: PlayerReportContentConfigDto;

  // charts area
  layout: PracticePitcherSessionReportChartConfigDto | undefined;
  chartData: PracticePitcherSessionReportChartDataDto[] | undefined;
};

const defaultValues: ReportSpecificTypes = {
  // search criteria area
  searchCriteria: {
    sessionType: { id: 'All', name: 'All' },
    dateRanges: undefined,
    seasonNames: undefined,
    players: undefined,
  },
  searchChips: {
    seasonNames: undefined,
    dateRanges: undefined,
    playerNames: undefined,
  },

  // filters / config area
  specialConfigOptions: undefined,
  selectedConfgValues: {
    pitchTagging: 'Auto',
    playerHandedness: 'Both',
    pitchGrouping: 'Types',
    pitchTypes: configurablePitchTypes,
    pitchTypeGroups: configurablePitchTypeGroups,
  },

  // charts area
  layout: undefined,
  chartData: undefined,
};

const useReportStore = generateStore(defaultValues);

export default useReportStore;
